import React from "react";
import ReactDOM from "react-dom";

interface Props {
  className?: string;
}

interface State {}

export class ToastsOverlay extends React.Component<Props, State> {
  static appRoot = document.getElementById("app-root");
  static toastsRoot = document.getElementById("toasts-root");

  el: HTMLElement;

  constructor(props: Props) {
    super(props);
    this.el = document.createElement("div");

    this.addClasses();
  }

  componentDidUpdate() {
    this.addClasses();
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    if (ToastsOverlay.toastsRoot !== null) {
      ToastsOverlay.toastsRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if (ToastsOverlay.toastsRoot !== null) {
      ToastsOverlay.toastsRoot.removeChild(this.el);
    }
  }

  addClasses() {
    if (this.props.className !== undefined) {
      const classes = this.props.className.split(" ");

      // First, we need to remove the other classes.
      this.el.classList.forEach((className) => {
        if (classes.indexOf(className) < 0) {
          this.el.classList.remove(className);
        }
      });

      classes.forEach((className) => this.el.classList.add(className));
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
